export default __webpack_public_path__ + "static/media/P730_D_BD.e82c0bad.pdf";